import styled from "styled-components";

export const Container = styled.div`
  max-width: 1220px;
  margin: 0 auto 10rem;
  padding: 2rem 0rem 3rem;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    margin-bottom: 2rem;
    
    font-size: 2rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    color: ${props => props.theme['text-title']};
    line-height: 4.5rem;
  }

  span {
    text-align: center;
    margin: 0rem 4rem 4rem 3rem;

    font-size: 1.5rem;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    color: ${props => props.theme['text-body']};
  }
`;

export const TechContent = styled.div`
  flex-direction: row;

  img {
    margin: 1.5rem 3rem  0 1.5rem 
  }
  
  img:hover {
    cursor: pointer;
    transition-duration: 0.2s;
    transform: scale(1.3);
    border-radius: 32px;
  }
`;

export const Row = styled.div`
  flex-direction: row;
`;